@if (resourceError) {
    <app-detail-resource-error
        [kind]="resourceError.kind"
        [titleKey]="resourceError.titleKey"
        [descriptionKey]="resourceError.descriptionKey"
        [showRetry]="resourceError.kind === 'generic'"
        (backEvent)="goBack($event)"
        (retryEvent)="getDetail()"
    />
}

@if(detail) {
<tec-detail-layout back backAction="emit" (backEvent)="goBack($event)">
    <div class="layout--60-40">
        <div class="layout__column">
            @if (errorActionMsg) {
                <tec-alert
                    status="error"
                    [msg]="errorActionMsg"
                    (closeAlert)="errorActionMsg = ''"
                />
            }
            <app-operation-detail-item
                [detail]="detail"
                (headerMenuAction)="onHeaderMenuAction($event)"
            />
            <app-operation-detail-tabs [detail]="detail" />
        </div>
        <div class="layout__column">
            @if (hasAsideMediaPreview()) {
                <app-operation-detail-media-preview [detail]="detail" />
            }
            <app-operation-detail-cards [detail]="detail" />
            @if (showAsideFinancialScoring()) {
                <tec-stats
                    [title]="financialEvaluationScoringTitle()"
                    [description]="'PROCESSES.DETAIL.SCORING' | translate"
                    statusType="alert"
                />
            }
            @if (showAsideFinancialDuration()) {
                <tec-stats
                    [title]="'PROCESSES.DETAIL.DURATION' | translate"
                    [description]="asideDurationAverageDescription()"
                    [value]="asideDurationValueFormatted()"
                    [tagRounded]="asideDurationTagRounded()"
                    [size]="'default'"
                />
            }
            <app-operation-detail-json [detail]="detail" />
        </div>
    </div>
</tec-detail-layout>
}

@if (detail && showModalChangeStatus) {
    <app-modal-change-status
        [id]="detail.uuid"
        [status]="$any(detail.state_name)"
        [statusEntity]="'operation'"
        (closeEvent)="closeChangeStatus($event)"
    />
}

@if (detail && showModalBlockIdentity) {
    <app-modal-block-identity
        [id]="identityUuidForModals"
        [locks]="$any(detail.locks)"
        [showOcrBlockOption]="showOcrBlockOption"
        [showFaceBlockOption]="showFaceBlockOption"
        (closeEvent)="closeBlockIdentity($event)"
    />
}

@if (detail && showModalUnlockIdentity) {
    <app-modal-unlock-identity
        [id]="identityUuidForModals"
        [locks]="$any(detail.locks)"
        [showOcrUnlockOption]="showOcrBlockOption"
        [showFaceUnlockOption]="showFaceBlockOption"
        (closeEvent)="closeUnlockIdentity($event)"
    />
}
